import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.InViewRoot),
  () => import('./InView'),
  (InView) => {
    ComponentUtil.binder(Hooks.InViewRoot, InView);
  },
);
